import type { Airport } from '../game/types';

const RAD = Math.PI / 180;

export function distanceKm(a: Airport, b: Airport): number {
  const dLat = (b.lat - a.lat) * RAD;
  const dLon = (b.lon - a.lon) * RAD;
  const value = Math.sin(dLat / 2) ** 2
    + Math.cos(a.lat * RAD) * Math.cos(b.lat * RAD) * Math.sin(dLon / 2) ** 2;
  return 2 * 6371 * Math.asin(Math.sqrt(value));
}

export function hashFloat(seed: number, ...values: number[]): number {
  let value = seed | 0;
  for (const item of values) {
    value = Math.imul(value ^ (item | 0), 0x45d9f3b);
    value ^= value >>> 16;
  }
  return ((value >>> 0) % 1_000_003) / 1_000_003;
}

export const clamp = (value: number, min: number, max: number) => Math.max(min, Math.min(max, value));

export function annuityPayment(principal: number, annualRate: number, weeks: number): number {
  const weeklyRate = annualRate / 52;
  return principal * weeklyRate / (1 - (1 + weeklyRate) ** -weeks);
}
